import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "col-md-3 mb-2" }
const _hoisted_2 = { class: "form-label" }

interface Props {
  label: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'BaseFilterComponent',
  props: {
    label: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", _hoisted_2, _toDisplayString(__props.label), 1),
    _renderSlot(_ctx.$slots, "default")
  ]))
}
}

})